import { useCallback, useEffect, useState } from "react";
import styles from "./AddresseManager.module.css";
import Button from "./Button";
import ModifyAddresse from "./ModifyAddresse";
import { getUserAddresses, setAddressToCart } from "services/api";
import NewAddress from "./NewAddress";
import ConfirmAddresse from "./ConfirmAddresse";
import Spinner from "./Spinner";

const AddresseManager = ({ tunnel = true, onSelectAddress, onAcceptConditions }) => {


  const [addresseModify, setAddresseModify] = useState(false);
  const [addressConfirmation, setAddressConfiramtion] = useState(false);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState({});
  const [loadingAddress, setLoadingAddress] = useState(false);

  const [addresses, setAddresses] = useState([]);


  const getAddresses = async () => {
    setLoadingAddress(true);
    const data = await getUserAddresses()
    setLoadingAddress(false);
    console.log(data);

    setAddresses(data);
  }

  useEffect(() => {
    console.log("getting addresses");
    getAddresses();
  }, []);
  useEffect(() => {
    if (addresses) {
      console.log("addresses data" + addresses);
    }
  }, [addresses]);


  return (
    <div className={`${styles.AddresseManager} ${tunnel ? styles.AddresseTunnel : ""}`}>

      {
        loadingAddress && <Spinner />
      }

      {!addresseModify && !addressConfirmation &&
        addresses.length > 0 &&
        addresses.map((address, index) => (

          <div className={styles.Addresse} key={index} style={address.id === selectedAddressId ? { border: "var(--pharos) 1px solid" } : {}}>
            <ul>
              <li>
                <strong>Identité :</strong> {address.raisonSociale ? `${address.raisonSociale} (${address.firstname} ${address.lastname})` : `${address.firstname} ${address.lastname}`}
              </li>
              {!!address.siret && <li>
                <strong>Siret :</strong> {address.siret}
              </li>}
              <li>
                <strong>Téléphone :</strong> {address.phone}
              </li>
              <li>
                <strong>Adresse :</strong> {address.address}, {address.zipCode} {address.city}
              </li>
            </ul>

            <div className={styles.AddresseAction}>
              {tunnel && <Button
                onClick={() => {
                  onSelectAddress(address.id);
                  setSelectedAddressId(address.id);
                  setSelectedAddress(address);
                  setAddressConfiramtion(!addressConfirmation);
                }}
              >Utiliser cette adresse</Button>}
              <Button variant={tunnel ? "white" : 'primary'} onClick={() => {
                setAddresseModify(!addresseModify)
                setSelectedAddress(address);
              }} >
                Modifier
              </Button>
            </div>

          </div>
        ))}


      {!addressConfirmation &&
        <>
          {addresseModify ?
            <ModifyAddresse onBack={() => {
              setAddresseModify(!addresseModify)
              getAddresses();
            }} data={selectedAddress} /> :
            <NewAddress tunnel={tunnel} refresh={() => {
              getAddresses();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }} />
          }
        </>

      }
      {
        addressConfirmation &&
        <ConfirmAddresse
          onBack={() => {
            setAddressConfiramtion(!addressConfirmation);
            setSelectedAddressId(null);
            getAddresses();
            onAcceptConditions(false);
          }}
          data={selectedAddress}
          onAcceptConditions={(value) => {
            onAcceptConditions(value);
          }}
        />
      }
    </div>
  );
}

export default AddresseManager;
